import React from "react";

import ChannelSelection from "src/banking/authentication/ForgotFlow/ChannelSelection";
import LoginRedirect from "src/banking/authentication/ForgotFlow/LoginRedirect";
import { handleCurrentState } from "../handleCurrentState";

import Entry from "./Entry";
import ResetQuestions from "./ResetQuestions";

export default {
  entry: Entry,
  selectChannel: props => (
    <ChannelSelection
      handleCurrentState={handleCurrentState}
      channelSelectionDescription={
        "olb.login.challengeQuestionChannelDescription"
      }
      {...props}
    />
  ),
  resetQuestions: props => <ResetQuestions {...props} />,
  forgotChallengeQuestionsComplete: () => (
    <LoginRedirect successMessage={"olb.login.resetChallenges.success"} />
  ),
  complete: () => (
    <LoginRedirect successMessage={"olb.login.resetChallenges.complete"} />
  ),
};



// WEBPACK FOOTER //
// ./src/banking/authentication/ForgotFlow/ForgotChallengeQuestions/steps/index.js